import React from "react";

const PeopleEmptyLight = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="155" height="155" viewBox="0 0 155 155" {...props}>
    <g clipPath="url(#clip0_203_40298)">
      <rect width="155" height="155" rx="77.5" fill="#F2F3F6" />
      <rect x="19" y="45" width="116" height="35.8235" rx="4" fill="#FCFCFC" />
      <circle cx="36.9118" cy="62.9117" r="9.38235" fill="#C5C7CC" />
      <rect x="54.8235" y="65.0439" width="38.6332" height="5.79498" rx="2.89749" fill="#DEE0E5" />
      <rect x="54.8235" y="54.8086" width="58" height="5.97059" rx="2.98529" fill="#C5C7CC" />
      <rect x="19" y="89" width="116" height="35.8235" rx="4" fill="#FCFCFC" />
      <circle cx="36.9118" cy="106.912" r="9.38235" fill="#C5C7CC" />
      <rect x="54.8235" y="109.044" width="38.6332" height="5.79498" rx="2.89749" fill="#DEE0E5" />
      <rect x="54.8235" y="98.8086" width="58" height="5.97059" rx="2.98529" fill="#C5C7CC" />
      <rect x="19" y="132.647" width="116" height="35.8235" rx="4" fill="#FCFCFC" />
      <circle cx="36.9118" cy="150.559" r="9.38235" fill="#C5C7CC" />
      <rect x="54.8235" y="152.691" width="38.6332" height="5.79498" rx="2.89749" fill="#DEE0E5" />
      <rect x="54.8235" y="142.456" width="58" height="5.97059" rx="2.98529" fill="#C5C7CC" />
    </g>
    <defs>
      <clipPath id="clip0_203_40298">
        <rect width="155" height="155" rx="77.5" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default PeopleEmptyLight;
